import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastOptions } from '@models/toast.models';
import { FULL_MAINTENANCE_MODE_ROUTE } from '@routes';
import { ToastService } from '@services/toast.service';
import { catchError, EMPTY, Observable } from 'rxjs';

@Injectable()
export class ErrorHandlingInterceptor implements HttpInterceptor {
  readonly #toastService: ToastService = inject(ToastService);
  readonly #router = inject(Router);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          this.showForbiddenMessage();
          throw error;
        }

        if (error instanceof HttpErrorResponse && error.status === 423) {
          console.log('Maintenance mode detected. Redirecting to maintenance mode page.', error);
          this.#router.navigate([FULL_MAINTENANCE_MODE_ROUTE], {
            queryParams: {
              until: error.error,
            },
          });
          return EMPTY;
        }

        this.showGenericErrorMessage();

        throw error;
      })
    );
  }

  readonly #genericToastConfig: ToastOptions = {
    type: 'error',
    title: 'common.http-error.title',
    message: 'common.http-error.description',
    actionText: '',
    inline: true,
    position: 'absolute',
    placement: 'top',
    autoHide: true,
    duration: 5000,
    animate: true,
  };

  showForbiddenMessage(): void {
    this.#toastService.showToast({
      ...this.#genericToastConfig,
      title: 'common.http-403-error.title',
      message: 'common.http-403-error.description',
    });
  }

  showGenericErrorMessage(): void {
    this.#toastService.showToast(this.#genericToastConfig);
  }
}
